import {client} from '../api/client'
import * as actions from "../actions/actiontypes"
import { TeacherEmail } from '../api/teacher'
const initialState = []

const dashboardReducer = (state = initialState, action)=> {
    switch(action.type) {
        case actions.DASHBOARD_LOAD:
        return action.payload
        default:
            return state;
    }
}
// Thunk function
export async function LogUpgradePopup(dispatch, getState) {
  const url = "https://nestback.storyworld.io/activity-logs/create";
  await fetch(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      usertype: "teacher",
      event: "upgrade-dashboard",
      location: "dashboard",
    }),
  });
}
export async function fetchDashboardConfig(dispatch, getState) {

    const response = await client.get(process.env.REACT_APP_API_BASE_URL+'/api/load/classes/'+TeacherEmail())
    if(response && response?.classes)
    // console.log(response.classes)
    dispatch({ type: actions.DASHBOARD_LOAD, payload: response.classes })
}

export default dashboardReducer;